export const isCoordinatorLikeRole = (role?: string | null): boolean => {
  return role === 'COORDINATOR' || role === 'DIRECTOR';
};
